
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types'

@Observer
@Component({
  components: {
    LazyImg,
    NewSwiper
  }
})
export default class NoBasic extends Vue {
  @Prop({ required: true }) readonly dataSource: CalligraphyLevel2JsonResp

  get picList() {
    return this.dataSource.welcomeAsk.noBasic
  }

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  activeIndex: number = 0

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  handleChange(index: number) {
    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
